// import axios from "@/axiosInterceptor";

const state = () => ({
  autocompleteService: null,
});

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  setAutocompleteService(state, data) {
    state.autocompleteService = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
